<script>
import {mapGetters} from "vuex";
import binpack from 'bin-pack.js';
import FlyerBlock from "@/components/block/FlyerBlock.vue";

export default {
	name: "GaplessGridLayout",
	components: {FlyerBlock},
	props:{
		blocks: {
			type: Array,
			default: () => []
		},
		align: {
			type: String,
			default: 'left'
		},
		inPlace:{
			type: Boolean,
			default: true
		}
	},
	computed:{
		...mapGetters('screen', ['flyerOrientation']),
		...mapGetters('scale', ['defPageGrid', 'defPage']),
		unitWidth(){
			return this.defPage.unitWidth;
		},
		unitHeight(){
			return this.defPage.unitHeight;
		},
		binBlocks() {
			return this.blocks.map(block => {
				const width = block.colSpan * this.unitWidth;
				const height = block.rowSpan * this.unitHeight;
				return {
					block,
					width,
					height
				}
			})
		},
		container() {
			return {
				width: this.flyerOrientation === 'vertical' ? this.pageWidth : Infinity,
				height: this.flyerOrientation === 'horizontal' ? this.pageHeight : Infinity,
			}
		},
		options() {
			return {align: this.align, inPlace: this.inPlace};
		},
		sortedBlocks() {
			let nodes = this.binBlocks;
			binpack.sort(nodes, 'area', 'ascending', false);
			binpack.pack(nodes, 'tree', this.container.width, this.container.height, 5, false )
			return nodes;
			//return binpack(this.container, this.binBlocks, 0);
		},
		pageWidth() {
			return this.defPageGrid.colCount * this.unitWidth;
		},
		pageHeight() {
			return this.defPageGrid.rowCount * this.unitHeight;
		},
		containerStyle() {
			const max = {x:0, y:0};
			const blocks = this.sortedBlocks;
			for (let i = 0; i < blocks.length; i++) {
				const block = blocks[i];
				max.x = Math.max(max.x, (block.x || 0) + block.width);
				max.y = Math.max(max.y, (block.y || 0) + block.height);
			}
			return {
				width: `${max.x}px`,
				height: `${max.y}px`
			};
		}
	},
	methods:{
		blockStyle(block) {
			const {x, y, width, height} = block;
			return {
				left: `${x}px`,
				top: `${y}px`,
				width: `${width}px`,
				height: `${height}px`
			};
		},

	}
}
</script>

<template>
	<div class="gapless-grid-layout" :style="containerStyle">
		<flyer-block v-for="(b, index) in sortedBlocks" :key="'search_result' + defPage.id + '_block_' + index"
		             :block-data="b.block" :blockKey="'search_result' + defPage.id + '_block_' + index"
		             :page="{ pageHeight , pageWidth, ...defPage, unitWidth, unitHeight }" root-scroll-container="search-scroll-container" :style="blockStyle(b)" />
	</div>
</template>

<style scoped lang="scss">
	.gapless-grid-layout {
	  position: relative;
	  .flyer-block {
	    position: absolute !important;
	  }
	}
</style>
